export default "__VITE_ASSET__BKDj7mGL__"